const model = {
    loading: false,
    error: null,
    urlToDownloadExcel: null,
    fileDownloadedSuccessfully: false,
}

export default model;